import React, { useState } from 'react';
import { useWindowSize } from '@react-hook/window-size';
import DataTable from 'react-data-table-component';
import {Modal, ModalBody, Row, Col, Button, InputGroup, InputGroupAddon, InputGroupText, Input,Form, Label, FormGroup  } from 'reactstrap';
import AddIndividuals from './AddIndividual';
import ContributorService from '../../../../api/services/ContributorService';
import TablesColumns from './TablesColumns';
import { dataTablesMobileStyledTheme, dataTablesStyledTheme} from  '../../../Utils/dataTablesStyledTheme';
import application_contants from '../../../contants/application_contants';
import { SearchOutlined } from '@material-ui/icons';
import debugLogger from '../../../Utils/debugLogger';
import Strip from '../../../customComponents/Strip/Strip';
import RenderPage from '../../../customComponents/RenderPage/RenderPage';
import Loader from '../../../customComponents/Loader/Loader';
import DashboardLayout from '../../../customComponents/InternalLayout/DashboardLayout';
import MessageConfirmation from '../../../customComponents/MessageConfirmation/MessageConfirmation';
import { alertDangerConfirmMessage, alertSuccessMessage } from '../../../customComponents/ConfirmationMessage/ConfirmationMessage';

const IndividualList = () => {
    const [width] = useWindowSize();
    const [filterText, setFilterText] = useState();
    const [data, setData] = useState([]);
    const [industryData, setIndustryData] = useState([]);
    const [individualData, setIndividualData] = useState([]);
    const [isAdd, setIsAdd] = useState(true);
    const [isModal, setIsModal] = useState(false);
    const [isConfirmModal, setIsConfirmModal] = useState(false);
    const [item, setItem] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [typeId, setTypeId] = useState('');
    // const { toggle } = props;

    React.useEffect(() => {
        getList();
    }, [isAdd]);
    const handleTypeId = (item) => {
        setTypeId(item)
    }

    const getList = async () => {
        setIsLoading(true);
        try {
            const res = await ContributorService.getContributorsList();
            console.debug('[IndividualList] getContributorsList response', res);
            if (res && res.success) {
                const payload = res.data || {};
                const list = (payload.individualList && Array.isArray(payload.individualList.list)) ? payload.individualList.list : [];
                debugLogger(payload);
                setData([...list]);
            } else {
                setData([]);
                setIndustryData([]);
                setIndividualData([]);
                console.warn('[IndividualList] unexpected response', res);
            }
        } catch (err) {
            console.error('[IndividualList] getList error', err);
            setData([]);
            setIndustryData([]);
            setIndividualData([]);
        } finally {
            setIsLoading(false);
        }
    };




    const handleOnChange = (event) => {
        setFilterText(event.target.value)
    }

    const handleClear = () => {
        setFilterText("");
    };

    const handleToggle = () => {
        setIsModal(!isModal);
        setIsAdd(true)
    };
    const handleToggleForAcademics = () => {
        setIsModal(!isModal);
        setIsAdd(true)
    };

    const handleRefresh = async () => {
        setIsModal(!isModal);
        setIsAdd(true);
        await getList();
    }

    const handleCancelBtn = async () => {
        setIsConfirmModal(false)
        setItem('');
    }

    const handleConfirmBtn = async () => {
        setIsConfirmModal(false);
        const userId = await localStorage.getItem('userId')
        let data = {
            id: item.id,
            status: item.status === 1 ? 0 : 1,
            userId: userId,
        };
        setIsLoading(true);
        try {
            const res = await ContributorService.enableDisableContributorsIndividual(data);
            console.debug('[IndividualList] enableDisableContributorsIndividual response', res);
            if (res && res.success) {
                const resultData = res.data || {};
                await getList();
                alertSuccessMessage(`${resultData.message || 'Updated successfully'}`);
            } else {
                alertDangerConfirmMessage(`${res && res.error ? res.error : 'Failed to update status'}`);
            }
        } catch (err) {
            console.error('[IndividualList] enable error', err);
            alertDangerConfirmMessage('Something went wrong.');
        } finally {
            setIsLoading(false);
        }
    }

    const handleEdit = (item) => {
        console.log(item)
        setIsModal(!isModal);
        setIsAdd(false);
        setItem(item);
    }

    const handleDelete = async (item) => {
        setIsConfirmModal(true)
        setItem(item);
    }


    return (
        <DashboardLayout>
            <RenderPage
                id="opening-page"
                className="mt-3"
                containerType="container-fluid"
            >
                <Strip
                    id="tst-opening"
                    className="strip strip-no-padding"
                    containerType="container"
                >
                    <Row className="">
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} className="">
                            <Row className="align-items-center mx-0">
                            <Col xs={7} sm={7} md={4} lg={3} xl={3}>
                                    <div className="d-flex align-items-center">
                                        <div>
                                            <Button
                                                className="btn custom-theme-btn custom-btn--small fs-14px br-4px"
                                                onClick={() => handleToggle()}
                                            >
                                                Add Individuals
                                            </Button>
                                        </div>

                                    </div>
                                </Col>
 
                            {isLoading ? (
                                <div className="loader-position">
                                    <Loader containerClassName="" />
                                </div>
                            ) : null}


                            </Row>

                        </Col>
                    </Row>
                    <Row className="mx-0">
                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                            <div className="pb-3 pt-3">
                            <h1 className="h1-small section-title align-left py-2">Individuals </h1>
                                {!isLoading ? (
                                    <DataTable
                                        title=""
                                        columns={TablesColumns(handleEdit, handleDelete)}
                                        data={data}
                                        pagination
                                        className="data-table"
                                        persistTableHead={false}
                                        customStyles={
                                            width > application_contants.MOBILE_BREAKPOINT
                                                ? dataTablesStyledTheme
                                                : dataTablesMobileStyledTheme
                                        }
                                    // onRowClicked={(data) => this.getHospitalItem(data)}
                                    />
                                ) : (
                                    <div className="pt-32px pb-64px d-flex justify-content-center">
                                        <Loader containerClassName="" />
                                    </div>
                                )}
                            </div>
                        </Col>
                    </Row>
                </Strip>
            </RenderPage>

            {isModal ? <AddIndividuals isModal={isModal} toggle={handleToggleForAcademics} isAdd={isAdd} item={item} handleRefresh={handleRefresh} /> : null}


            {isConfirmModal ? (
                <MessageConfirmation
                    isModal={isConfirmModal}
                    handleCancelBtn={handleCancelBtn}
                    handleConfirmBtn={handleConfirmBtn}
                    message={`Are you sure you want to ${item.status === 1 ? 'disable' : 'enable'} this user?`}
                />
            ) : null}
        </DashboardLayout>
    )
}
export default IndividualList;